import { Component, OnInit } from '@angular/core';
import { MapDirective } from 'app/spatial/directives/map.directive';

@Component({
  selector: 'app-map-create-site',
  templateUrl: './map-create-site.component.html',
  styleUrls: ['./map-create-site.component.css'],
  imports:[MapDirective],
  host:{
    class: 'block h-dvh w-dvw'
  }
})
export class MapCreateSiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
